import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppServiceHelperService } from './app-service-helper.service';

/**
 * Angular integration service: Use this to communicate from the Angular to AngularJS part of the application
 */
@Injectable()
export class ArgusIntegrationService {
  /**
   * Export to Argus resource
   */
  private _exportToArgusResource: string;

  /**
   * Constructor
   * @param appServiceHelper AppServiceHelperService
   * @param httpClient HttpClient
   */
  constructor(private httpClient: HttpClient, private appServiceHelper: AppServiceHelperService) {
    this._exportToArgusResource = this.appServiceHelper.getServiceEndpoint('pollux.argus.integration.api', 'argus/Valuation');
  }

  /**
   * Creates/updates the portfolio on the Argus
   * @param argusPropertyAsset The portfolios that will be created/updated
   */
  public createArgusPortfolio(portfolios: any): Observable<any> {
    if (!Array.isArray(portfolios)) {
      portfolios = [portfolios]; // convert to array
    }
    return this.httpClient.post<any>(`${this._exportToArgusResource}/create/portfolio`, portfolios);
  }

  /**
   * Creates/updates the property on the Argus
   * @param argusPropertyAsset The properties that will be created/updated
   */
  createArgusPropertyAsset(argusPropertyAsset: any): Observable<any> {
    return this.httpClient.post<any>(`${this._exportToArgusResource}/create/property/asset`, argusPropertyAsset);
  }

  /**
   * Retreives portfolios that have been pushed to argus
   * @param projectId The project id of a valuation event
   * */
  getArgusValuations(projectId : number, valuationPortfolioId : number): Observable<any> {
    return this.httpClient.get<any>(`${this._exportToArgusResource}/valuations?projectId=${projectId}&valuationPortfolioId=${valuationPortfolioId}`);
  }

  /**
   * Copies an Argus valuation
   * @param copyFromPortfolioId
   * @param selectedPortfolioId
   * @returns
   */
  copyArgusValuation(copyFromPortfolioId: any, selectedPortfolioId: any): Observable<any> {
    return this.httpClient.post<any>(`${this._exportToArgusResource}/copy/portfolio/${copyFromPortfolioId}/${selectedPortfolioId}`, null);
  }

  /**
   * Gets Argus logs
   * @param valuationProjectId
   * @param propertyId
   * @returns
   */
  getArgusLogs(valuationProjectId: number, propertyId : number): Observable<any> {
    return this.httpClient.get<any>(`${this._exportToArgusResource}/getLogs?valuationProjectId=${valuationProjectId}&propertyId=${propertyId}`);
  }
}
